import { ValidationError } from '../errors';
import { validatePhone } from './validatePhone';
import { validateTime } from './validateTime';
export var validateForm = function validateForm(values, options) {
  var timezoneDiff = options.timezoneDiff,
      workTime = options.workTime;
  var errors = {
    customerPhone: validatePhone(values.phone),
    time: validateTime(values.time, workTime, timezoneDiff)
  };

  if (Object.values(errors).filter(Boolean).length > 0) {
    var error = new ValidationError({
      domain: 'callback-widget.validateForm()',
      message: 'Callback widget validation error',
      errors: errors
    });
    throw error;
  }
};